const STORAGE_KEY = "orderReceipts";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // must match RECEIPT_TOKEN_TTL_MS in the lambda

const toHex = (bytes) =>
  Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

function readAll() {
  try {
    const all = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    const now = Date.now();
    Object.keys(all).forEach((k) => {
      if (!all[k] || now - all[k].createdAt > MAX_AGE_MS) delete all[k];
    });
    return all;
  } catch (e) {
    return {};
  }
}

function writeAll(all) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch (e) {
    // storage blocked/full - user still gets the email
  }
}

// Returns { token, hash } or null if Web Crypto is unavailable.
export async function createOrderReceipt() {
  try {
    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);
    const token = toHex(bytes);
    const digest = await window.crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(token),
    );
    return { token, hash: toHex(new Uint8Array(digest)) };
  } catch (e) {
    console.log("createOrderReceipt error:", e);
    return null;
  }
}

export function saveOrderReceipt(orderID, orderRecordId, token) {
  if (!orderID || !orderRecordId || !token) return;
  const all = readAll();
  all[orderID] = { orderRecordId, token, createdAt: Date.now() };
  writeAll(all);
}

export function getOrderReceipt(orderID) {
  const all = readAll();
  writeAll(all); // persist pruning
  return all[orderID] || null;
}